import { translateFunc } from "client/utils/translateFunc";
import { DownloadIcon } from "components/common/Icons/DownloadIcon";
import { Loader } from "components/common/Icons/Loader/Loader";
import { useAction } from "./useAction";
import { stopPropagation } from "client/utils/stopPropagation";

export const DesktopAction = () => {
    const { handleClick, isProcessing } = useAction();

    return (
        <div className="p-4">
            <div
                className={`cursor-pointer ${
                    isProcessing
                        ? "bg-irGray-400 dark:bg-darkSurface-600 dark:hover:bg-darkSurface-500 hover:bg-irGray-600"
                        : "bg-irBlue-200 dark:bg-darkPrimary-100 dark:hover:bg-darkPrimary-200 hover:bg-irBlue-400"
                }  text-white text-center flex items-center justify-center gap-2 capitalize font-semibold px-6 py-2 rounded-xl text-2xl`}
                onClick={stopPropagation(handleClick)}
                data-testid={`${isProcessing ? "active" : "inactive"}-download-button`}
            >
                {isProcessing ? (
                    <Loader width={20} height={20} className="stroke-white" />
                ) : (
                    <DownloadIcon width={20} height={20} />
                )}
                <div className="">{translateFunc("common:download")}</div>
            </div>
        </div>
    );
};
